import React, { useCallback } from 'react'
import { BookingForm } from 'pages/bookings/BookingForm'
import { PromptModal } from 'components'
import { useHistory } from 'react-router-dom'
import { useCreateBooking } from 'api'
import { useTranslation } from 'react-i18next'

export const NewBookingPage = () => {
  const { t } = useTranslation()

  const history = useHistory()
  const navigateToOverview = useCallback(
    () => history.push('/bookings'),
    [history]
  )

  const [mutate, { status, data, reset }] = useCreateBooking()
  const onSubmit = useCallback(
    (values, { setSubmitting }) => {
      mutate({ booking: values })
      setSubmitting(false)
    },
    [mutate]
  )

  return (
    <>
      <h1 id="new-booking-headline-e2e">
        {t('pages.bookings.newBookingPage.heading')}
      </h1>

      <BookingForm onSubmit={onSubmit} />

      {status === 'success' && (
        <PromptModal
          headline={t('pages.bookings.newBookingPage.success.headline')}
          confirmCallback={navigateToOverview}
          confirmText={t('pages.bookings.newBookingPage.success.confirm')}
        >
          {t('pages.bookings.newBookingPage.success.newBooking', {orderNumber: data?.orderNumber})}
        </PromptModal>
      )}

      {status === 'failure' && (
        <PromptModal
          headline={t('pages.bookings.newBookingPage.failure.headline')}
          confirmCallback={reset}
          confirmText={t('pages.bookings.newBookingPage.failure.confirm')}
        >
          {t('pages.bookings.newBookingPage.failure.newBooking')}
        </PromptModal>
      )}
    </>
  )
}
